<template>
  <div id="home" class="max-w-1800 wp_AllPageMarginTop pb-4"
       :class="getAllPromotions.length<=0?'nomasthead':''"
  >
    <!--<loading :active.sync="isLoading"-->
    <!--:can-cancel="false"-->
    <!--:on-cancel="onCancel"-->
    <!--:is-full-page="fullPage"-->
    <!--:opacity=0.95-->
    <!--&gt;-->
    <!--<div class="jin" v-if="isLoading">-->
      <!--<div class="jin-loader">-->
        <!--<svg class="jin-loader-circular" viewBox="25 25 50 50">-->
          <!--<circle class="jin-loader-path"-->
                  <!--cx="50"-->
                  <!--cy="50"-->
                  <!--r="20"-->
                  <!--fill="none"-->
                  <!--stroke-width="3"-->
                  <!--stroke-miterlimit="9"-->
          <!--&gt;-->
          <!--</circle>-->
        <!--</svg>-->
      <!--</div>-->
    <!--</div>-->
    <!--</loading>-->
    <mast-head-carousel :allPromotions="getAllPromotions">
    </mast-head-carousel>
    <three-column-banner :allPromotions="getAllPromotions">
    </three-column-banner>
    <tab-section>
    </tab-section>
    <!--<review-product v-if="isAuthenticated && getTotalOrderData">-->
    <!--</review-product>-->
			<section>
    <product-list-slider title="All Products"
                         v-if="productSliderData && productSliderData.length === 10"
                         :products="productSliderData"
    >
    </product-list-slider>
				<product-list-slider title="Recommended Products"
																										v-if="recommendedProductSliderData.length>0 && isAuthenticated"
																										:products="recommendedProductSliderData"
					>
					</product-list-slider>
				<section v-for="(category,index) in categorySliderData"
													:key="index">
					<product-list-slider-2 :categoryListData="category"
																												v-if="segmentSelected(category.eventName)"
					/>
				</section>
			</section>
    <!--<product-list-slider-->
    <!--title="Recently Viewed"-->
    <!--v-if="recentProducts"-->
    <!--:products="recentProducts"-->
    <!--&gt;-->
    <!--</product-list-slider>-->
    <!--<product-list-slider-2-->
    <!--title="Category"-->
    <!--v-for="(category, index) in getCategoryData" :key="category.category_name"-->
    <!--v-if="(getCategoryData && getCategoryData.length > 0 && index < 1)"-->
    <!--:categories="category"-->
    <!--&gt;-->
    <!--</product-list-slider-2>-->

    <!--<load-more-section>-->
    <!--</load-more-section>-->
  </div>
</template>

<script>
// import Loading from 'vue-loading-overlay'
// import 'vue-loading-overlay/dist/vue-loading.css'
import MastHeadCarousel from '@/components/widgets/home/MastHeadCarousel'
import ThreeColumnBanner from '@/components/widgets/home/ThreeColumnBanner'
import TabSection from '@/components/widgets/home/TabSection'
import ProductListSlider from '@/components/widgets/home/ProductListSlider'
// import ProductListSlider2 from '@/components/widgets/home/ProductListSlider2'
// import LoadMoreSection from '@/components/widgets/LoadMoreSection'
import { productApi } from '@/services/ApiServices/productApi'
import { mapActions, mapGetters } from 'vuex'
import { store } from '@/store/store'
import ProductListSlider2 from '../../widgets/home/ProductListSlider2'
import { unomiApis } from '../../../services/ApiServices/unomiApis'
// import ReviewProduct from '../../widgets/ReviewProduct'

export default {
	components: {
		ProductListSlider2,
		MastHeadCarousel,
		ThreeColumnBanner,
		TabSection,
		ProductListSlider
		// ProductListSlider2,
		// LoadMoreSection,
		// Loading
		// ReviewProduct
	},
	data () {
		return {
			products: {},
			index_start: 0,
			count_index: 10,
			length: 100,
			count: 0,
			length_all_products: 0,
			recentProducts: [],
			isLoading: false,
			fullPage: true,
			recommendCount: 10,
			categorySliderData: [
				{
					title: 'Grocery',
					serviceName: 'getCategoryOne',
					eventName: 'grocerySegment',
					category: {
						'name': 'grocery',
						'category_id': 'grocery',
						'is_a_category': true
					}
					// products: this.getCategoryOneProducts
				},
				{
					title: 'Men',
					serviceName: 'getCategoryTwo',
					eventName: 'menFashionSegment',
					category: {
						'name': 'men',
						'category_id': 'men',
						'is_a_category': true
					}
					// products: this.getCategoryTwoProducts
				},
				{
					title: 'Women',
					serviceName: 'getCategoryThree',
					eventName: 'wommenFashionSegment',
					category: {
						'name': 'womens',
						'category_id': 'womens',
						'is_a_category': true
					}
					// products: this.getCategoryThreeProducts
				}
			]
		}
	},
	mounted () {
		this.pageScroll()
		unomiApis.getSegments()
	},
	computed: {
		...mapGetters('recentview', ['getRecentViewedProducts', 'getRecentViewedProductsData']),
		...mapGetters('category', ['getCategoryData']),
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('home', ['getrecommendedProduct', 'getCategoryOneProducts', 'getCategoryTwoProducts', 'getCategoryThreeProducts']),
		...mapGetters('promotions', ['getAllPromotions']),
		...mapGetters('order', ['getTotalOrderData']),
		...mapGetters('analytics', ['getSegmentsData']),
		productSliderData () {
			if (this.getSelectedProduct && this.getSelectedProduct.length > 10) {
				return this.getSelectedProduct.slice(0, 10)
			}
			return this.getSelectedProduct
		},
		recommendedProductSliderData () {
			if (this.getrecommendedProduct) {
				return this.getrecommendedProduct.slice(0, 10)
			}
			return this.getrecommendedProduct
		}
	},
	beforeMount () {
		this.getProducts('getSearchedFilteredProducts', this.length)
		store.dispatch('buynow/deleteFromBuyNow')
		this.isLoading = true
		productApi.getPromotions()
		if (this.isAuthenticated) {
			productApi.getRecommendedProducts(this.recommendCount)
		}
		// productApi.getProductsByIds(this.getRecentViewedProducts, 'recentProducts').then(() => {
		//   this.isLoading = false;
		//   this.recentProducts = this.getRecentViewedProductsData;
		//   // setTimeout(() => {
		//   //   this.ismasthead-carousel-Loading = false;
		//   // }, 100);
		// }).catch(() => {
		// });
	},
	methods: {
		pageScroll () {
			if (screen.width >= 476) {
				let prevScrollpos = window.pageYOffset
				window.onscroll = function () {
					const currentScrollPos = window.pageYOffset
					if ((prevScrollpos > currentScrollPos) && document.getElementById('wp_CategoryNav') && document.getElementById('wp_CategoryNav').style) {
						document.getElementById('wp_CategoryNav').style.top = '59px'
					} else if (document.getElementById('wp_CategoryNav') && document.getElementById('wp_CategoryNav').style) {
						document.getElementById('wp_CategoryNav').style.top = '0'
					}
					prevScrollpos = currentScrollPos
				}
			}
		},
		segmentSelected (eventName) {
			return this.getSegmentsData.includes(eventName)
		},
		getProducts (name, length) {
			this.isLoading = true
			// productApi[name](this.index_start, this.count_index)
			productApi[name]({
				filter_class: {
					filters: [],
					brands: [],
					ratings: []
				}
			}, 'filteredAllProducts', 'ASC', 'NAME', 0, this.length + (length * this.count))
				.then((res) => {
					if (res) {
						this.isLoading = false
						this.products[name] = this.getSelectedProduct
						this.count += 1
						this.length_all_products = this.getSelectedProduct.length
						// setTimeout(() => {
						//   this.isLoading = false;
						// }, 100);
						this.$forceUpdate()
					}
				})
		},

		...mapActions('productselected', ['setSelectedProductData']),
		...mapActions('category', ['setActiveCategories']),
		...mapActions('filters', ['updatePriceRange', 'updateFilterApplied', 'updateKeyWord']),
		viewAllProducts () {
			this.$router.push({
				name: 'AllProducts',
				path: '/all-products',
				query: {
					display_text: 'All Products',
					called_index_value: this.index_start,
					called_count_value: this.count_index,
					product_length: this.length_all_products
				}
			})
		}
		// doAjax() {
		//   this.isLoading = true;
		//   // simulate AJAX
		//   setTimeout(() => {
		//     this.isLoading = false;
		//   }, 5000);
		// },
	}
}
</script>

<style scoped>
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }

  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid blue;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: blue transparent transparent transparent;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .vld-overlay.is-full-page {
    z-index: 2999 !important;
  }
</style>
